import Carousel from 'react-multi-carousel'
import { Link } from 'react-router-dom'
import { useConfig } from '../../../Providers/ConfigProvider'


const HomeSlider = ({ homeSliderItems }) => {
  const { dataUrl } = useConfig()

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 767, min: 100 },
      items: 1,
      slidesToSlide: 1 // optional, default to 1.
    }
  };
  return (
    <div className="col-12 gd-carousel-wrapper">
      <Carousel
        className='gd-carousel-home-page'
        responsive={responsive}
        autoPlay={true}
        swipeable={true}
        draggable={true}
        showDots={true}
        infinite={true}
        autoPlaySpeed={6000}
        partialVisbile={false}
        ssr={true}
      >
        {homeSliderItems.map(imageSlide => (
          <div key={imageSlide.sliderItemId}>
            <Link to={imageSlide.url}>
              <img src={`${dataUrl}/banery/${imageSlide.fileName}`} className="img-fluid w-100" alt={imageSlide.description} />
            </Link>
          </div>
        ))}
      </Carousel>
    </div>
  )
}

export default HomeSlider